// @TODO: unify with homepage search
export default function mainHeaderSearch() {

    const searchForm = document.getElementById('search-form');
    const headerSearchClose = document.getElementById('closed_icon');
    const headerSearchInput = document.getElementById('search-input');
    const searchActiveClass = 'search_active';

    if ( !(searchForm && headerSearchInput && headerSearchClose) ) {
        return;
    }

    searchForm.addEventListener("submit", function(e){
        e.preventDefault();

        const reportValidity = this.reportValidity ? this.reportValidity() : true;
        if (reportValidity) {
            window.location.href = searchForm.getAttribute('action') + headerSearchInput.value;
            return false;
        }

    });


    document.querySelector('.search-cta').addEventListener('click', function(e) {
        document.body.classList.add(searchActiveClass);
        document.getElementById('e-header').classList.add('ov-hidden');

        setTimeout(function() {
            headerSearchInput.focus();
        }, 500);
    });

    headerSearchClose.addEventListener('click', function(e) {
        e.preventDefault();

        //clear on first click
        if (headerSearchInput.value) {
            headerSearchInput.value = '';
            return;
        }

        //close search when search input is empty
        document.body.classList.remove(searchActiveClass);
        setTimeout(function(){
            headerSearchInput.blur();
            document.getElementById('e-header').classList.remove('ov-hidden');
        }, 500);
    });
}

